import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { IceapiService, UserUtilityService } from 'src/app/services';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { boltLoadGroup } from '../../../models/boltLoadGroups';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-tightening-specification',
    templateUrl: './tightening-specification.component.html',
    styleUrls: ['./tightening-specification.component.scss'],
})
export class TighteningSpecificationComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set isEngineeredJoint(value: boolean) {
        this._isEngineeredJoint = value;
    }
    get isEngineeredJoint(): boolean {
        return this._isEngineeredJoint;
    }

    @Input()
    set calculationType(value) {
        this._calcType = value;
        if (value == CalculationType.StandardFlange || value == CalculationType.CustomFlange || value == CalculationType.EngineeredJoint) {
            this.getBoltLoadGroup(value);
        }
    }
    get calculationType() {
        return this._calcType;
    }
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    tightningSpecList: boltLoadGroup[];
    tightningSpecList1: boltLoadGroup[];
    tightningSpecList2: boltLoadGroup[];
    istighteningSpecOverideInput: boolean = false;
    _calcType;
    private _isEngineeredJoint: boolean;

    constructor(
        private measSvc: MeasurementService,
        private globalEmittersService: GlobalEmittersService,
        private cd: ChangeDetectorRef,
        private jointcalcService: JointCalcService,
        private router: Router,
        private iceApiService: IceapiService,
        private userUtilityService: UserUtilityService,
        private dataService: DataService,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        this.globalEmittersService.currentCalculationType.pipe(takeUntil(this.destroy$)).subscribe((calcType) => {
            if (calcType == CalculationType.StandardFlange || calcType == CalculationType.CustomFlange || calcType == CalculationType.EngineeredJoint) {
                this.getBoltLoadGroup(calcType);
            }
        });

        this.form
            .get('tighteningSpecification')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (!this.jointCalcService.isPipeCode) {
                    this.form.get('tighteningSpecOveride').reset('');
                }
                if (this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) {
                    this.jointcalcService.selectedTighteningSpecification.next(value);
                }

                if (value == 'TorqueLongForm' || value == 'TorqueShortForm') {
                    this.globalEmittersService.lubricantUnitTighteningSpecification.next({ isEvent: true, dropdownValue: value });
                    this.globalEmittersService.openControlProcedurePanel.next(true);
                }

                this.istighteningSpecOverideInput = this.tightningSpecList?.find((x) => x.key == this.form.get('tighteningSpecification').value)?.allowInput;
                if (this.istighteningSpecOverideInput) {
                    this.form.get('tighteningSpecOveride').setValidators(Validators.required);
                    this.form.markAllAsTouched();
                    this.cd.markForCheck();
                } else {
                    this.form.get('tighteningSpecOveride').clearValidators();
                    this.form.get('tighteningSpecOveride').updateValueAndValidity();

                    this.form.markAllAsTouched();
                    this.cd.markForCheck();
                }
                if (
                    this.jointCalcService.isPipeCode &&
                    (this.router.url.includes('/idms/plantmanagerView') || this.router.url == '/idms/plantmanager') &&
                    this.form.get('tighteningSpecification') &&
                    this.tightningSpecList?.find((x) => x.key == this.form.get('tighteningSpecification').value)?.allowInput
                ) {
                    if (
                        this.dataService?.calculationData?.input?.others?.tighteningSpecificationInput &&
                        this.dataService.calculationData.input.others.tighteningSpecification == value
                    )
                        this.form.get('tighteningSpecOveride').setValue(this.dataService?.calculationData?.input?.others?.tighteningSpecificationInput);
                    else {
                        if (this.jointcalcService.PipeSpecFilteredList?.length == 1) {
                            this.form
                                .get('tighteningSpecOveride')
                                .setValue(
                                    this.jointcalcService.PipeSpecFilteredList[0].others.tighteningSpecificationInput
                                        ? this.jointcalcService.PipeSpecFilteredList[0].others.tighteningSpecificationInput
                                        : ''
                                );
                        } else {
                            let obj = this.jointcalcService.PipeSpecFilteredList.find(
                                (x) => x.others.tighteningSpecification == this.form.get('tighteningSpecification').value
                            );
                            this.form
                                .get('tighteningSpecOveride')
                                .setValue(obj?.others?.tighteningSpecificationInput ? obj.others.tighteningSpecificationInput : '');
                        }
                    }
                }
            });

        this.form
            .get('tighteningSpecOveride')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.formatTighteningSpecValue(value, this.form.get('tighteningSpecification').value));

        this.jointcalcService.selectedboltMaterial.pipe(takeUntil(this.destroy$)).subscribe(async (bt) => {
            let data = [];

            if (bt && this.jointcalcService.pipeSpecpayload.lookupParams.calculationType == CalculationType.StandardFlange) {
                this.jointcalcService.pipeSpecpayload.lookupParams.recordId.boltMaterialId = bt;

                let boltGroupdata = await this.iceApiService.getBoltLoadGroups(localStorage.getItem('currentInstanceId'), this.calculationType).toPromise();

                if (this.jointcalcService.PipeSpecFilteredList.length > 0) {
                    data = await this.jointcalcService.filterList(this.jointcalcService.pipeSpecpayload.lookupParams);
                }

                let standardpipeSpec = [...new Set([...data].map((x) => x.others.tighteningSpecification))];

                if (standardpipeSpec?.length) {
                    this.tightningSpecList = boltGroupdata.response.filter((item) => standardpipeSpec.includes(item?.key));
                    this.tightningSpecList1 = [...this.tightningSpecList].filter((x) => x?.boltLoadGroupId);
                    this.tightningSpecList2 = [...this.tightningSpecList].filter((x) => !x?.boltLoadGroupId);

                    if (
                        this.dataService.calculationData?.input?.others?.tighteningSpecification &&
                        this.tightningSpecList.some((x) => x.key == this.dataService.calculationData.input.others.tighteningSpecification)
                    ) {
                        this.form.get('tighteningSpecification').setValue(this.dataService.calculationData?.input?.others?.tighteningSpecification);
                    } else if (this.tightningSpecList.length == 1) {
                        this.form.get('tighteningSpecification').setValue(this.tightningSpecList[0].key);
                    }
                }
                if (
                    !this.dataService.calculationData?.input?.others?.tighteningSpecification &&
                    !(this.jointCalcService.isPipeCode && (this.router.url.includes('/idms/plantmanagerView') || this.router.url == '/idms/plantmanager'))
                ) {
                    const copiedArray = [...this.jointcalcService.PipeSpecFilteredList];

                    copiedArray.forEach((x) => {
                        if (x.others.tighteningSpecification == 'Informate Recommended') {
                            this.form.get('tighteningSpecification').setValue('Informate Recommended');
                        }
                    });
                }

                // this.tightningSpecList = new Map(matchingTighteningSpecList);
            }
        });

        this.globalEmittersService.unitUpdated.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp) {
                let val = this.form.get('tighteningSpecOveride').value;
                if (val.includes('Nm')) {
                    val = val.replace(/\s*Nm/i, '');
                }
                if (val.includes('Lbf.ft')) {
                    val = val.replace(/\s*Lbf.ft/i, '');
                }

                if (val != '') {
                    this.formatTighteningSpecValue(val, this.form.get('tighteningSpecification').value);
                    this.cd.detectChanges();
                }
            }
        });
    }

    formatTighteningSpecValue(value: string, tighteningSpec: string): void {
        let formatedValue: string = '';
        switch (tighteningSpec) {
            case 'BoltLoad':
                this.form.get('tighteningSpecOveride').clearValidators();
                this.form.get('tighteningSpecOveride').setValidators([Validators.required]);
                formatedValue = this.measSvc.format(value, UnitType.DefaultForceUnit);
                break;
            case 'BoltStress':
            case 'GasketStress':
                this.form.get('tighteningSpecOveride').clearValidators();
                this.form.get('tighteningSpecOveride').setValidators([Validators.required]);
                formatedValue = this.measSvc.format(value, UnitType.DefaultStressUnit);
                break;

            case 'PercentageYieldResidual':
                this.form.get('tighteningSpecOveride').setValidators([Validators.min(0), Validators.max(100)]);
                formatedValue = this.measSvc.format(value, UnitType.DefaultPercentageUnit);
                break;
            case 'TorqueLongForm':
                this.form.get('tighteningSpecOveride').clearValidators();
                this.form.get('tighteningSpecOveride').setValidators([Validators.required]);
                formatedValue = this.measSvc.format(value, UnitType.DefaultTorqueUnit);
                break;
            case 'Extension':
            case 'TorqueShortForm':
                this.form.get('tighteningSpecOveride').clearValidators();
                this.form.get('tighteningSpecOveride').setValidators([Validators.required]);
                formatedValue = this.measSvc.format(value, UnitType.DefaultTorqueUnit);
                break;

            case 'TurnOfNut':
                this.form.get('tighteningSpecOveride').clearValidators();
                this.form.get('tighteningSpecOveride').setValidators([Validators.required]);
                formatedValue = this.measSvc.format(value, UnitType.DefaultAngleUnit);
                break;
        }
        this.form.get('tighteningSpecOveride').patchValue(formatedValue, { emitEvent: false });

        this.cd.detectChanges();
    }

    async getBoltLoadGroup(calcType) {
        try {
            let boltGroupdata = await this.iceApiService.getBoltLoadGroups(localStorage.getItem('currentInstanceId'), calcType).toPromise();
            if (boltGroupdata.success) {
                this.tightningSpecList = boltGroupdata.response;
                this.tightningSpecList1 = boltGroupdata.response.filter((x) => x?.boltLoadGroupId);
                this.tightningSpecList2 = boltGroupdata.response.filter((x) => !x?.boltLoadGroupId);
                this.istighteningSpecOverideInput = this.tightningSpecList?.find((x) => x.key == this.form.get('tighteningSpecification').value)?.allowInput;
            } else {
                this.userUtilityService.errorModelPopup(boltGroupdata.message);
            }
        } catch (e) {}
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
